/* Watt Wheelz V63.4: Move the existing, single reassurance blocks under
   the desktop gallery. Keep their original post-buy placement on mobile.
   Never touch product form, variants, gifts, SureBright, or ATC nodes. */
(function(){
  function init(scope){
    var roots=(scope||document).querySelectorAll('[data-product-root]');
    Array.prototype.forEach.call(roots,function(root){
      if(root.dataset.wwTrustLayoutReady==='1')return;
      var visual=root.querySelector('[data-ww-pdp-trust-target]');
      var purchase=root.querySelector('.ww-product__purchase');
      if(!visual||!purchase)return;
      var selectors=['.ww-pdp-assurance','.ww-reassurance-disclosure','.ww-price-match--pdp'];
      var groups=selectors.map(function(selector){
        return purchase.querySelector(selector);
      }).filter(Boolean);
      if(groups.length<2)return;
      var anchors=groups.map(function(element,index){
        var marker=document.createComment('WWZ trust original location '+index);
        element.parentNode.insertBefore(marker,element);
        return {element:element,marker:marker};
      });
      root.dataset.wwTrustLayoutReady='1';
      var mq=window.matchMedia('(min-width: 991px)');
      function apply(){
        if(mq.matches){
          anchors.forEach(function(pair){visual.appendChild(pair.element);});
        }else{
          anchors.forEach(function(pair){
            if(pair.marker.parentNode)pair.marker.parentNode.insertBefore(pair.element,pair.marker.nextSibling);
          });
        }
      }
      apply();
      if(mq.addEventListener)mq.addEventListener('change',apply);
      else if(mq.addListener)mq.addListener(apply);
    });
  }
  function run(){init(document)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();